import { Badge } from '@/components/ui/badge';
import type { DeliveryInvoiceStatusBadgeConfig } from './deliveryInvoiceStatus';

export const DeliveryInvoiceStatusBadge = ({
  status,
}: {
  status: DeliveryInvoiceStatusBadgeConfig;
}) => {
  return (
    <Badge className={status.className}>
      {status.label}
    </Badge>
  );
};
